import React from 'react';
import { SimulatorRoom } from '../../Types/SimulatorRoom';
import clsx from 'clsx';
import Product from '../../Types/Product';
import WallpaperSimulatorProductSelector from './WallpaperSimulatorProductSelector';
import WallPaperSimulatorRoomSelector from './WallPaperSimulatorRoomSelector';
import { translate } from '../../Services/translation';
import Icon from '../Icon';

interface ConfiguratorInterface {
  simulatorRooms: SimulatorRoom[];
  selectedRoom: SimulatorRoom;
  setSelectedRoom: (room: SimulatorRoom) => void;
  setSelectedProduct: (product: Product) => void;
  products: Product[];
  roomSelectorOpen: boolean;
  setRoomSelectorOpen: (open: boolean) => void;
  productSelectorOpen: boolean;
  setProductSelectorOpen: (open: boolean) => void;
  totalProductsCount: number;
  currentPage: number;
  pageSize: number;
}
const WallPaperSimulatorConfigurator = ({
  simulatorRooms,
  selectedRoom,
  setSelectedRoom,
  setSelectedProduct,
  products,
  roomSelectorOpen,
  setRoomSelectorOpen,
  productSelectorOpen,
  setProductSelectorOpen,
  totalProductsCount,
  currentPage,
  pageSize,
}: ConfiguratorInterface) => {
  return (
    <>
      <div>
        <div className="mb-4 rounded border border-gray-100">
          <label
            className="flex cursor-pointer items-center py-2.5 pl-4 pr-2"
            onClick={() => setRoomSelectorOpen(!roomSelectorOpen)}
          >
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-h5">
              1
            </div>
            <h4 className="ml-2 flex flex-1">
              {translate('simulator.choose-room')}
            </h4>
            <div className="p-3">
              <Icon
                name="chevron-left"
                className={clsx(
                  'h-5 w-5 transition-transform',
                  roomSelectorOpen ? 'rotate-90' : 'rotate-[270deg] '
                )}
              />
            </div>
          </label>
          <div
            className={clsx(
              'grid w-full transition-[grid-template-rows] duration-200',
              roomSelectorOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
            )}
          >
            <div className="overflow-hidden">
              <WallPaperSimulatorRoomSelector
                simulatorRooms={simulatorRooms}
                selectedRoom={selectedRoom}
                setSelectedRoom={setSelectedRoom}
              />
            </div>
          </div>
        </div>
        <div className="mb-4 rounded border border-gray-100">
          <label
            className="flex cursor-pointer items-center py-2.5 pl-4 pr-2"
            onClick={() => setProductSelectorOpen(!productSelectorOpen)}
          >
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-h5">
              2
            </div>
            <h4 className="ml-2 flex flex-1">
              {translate('simulator.choose-wallpaper')}
            </h4>
            <div className="p-3">
              <Icon
                name="chevron-left"
                className={clsx(
                  'h-5 w-5 transition-transform',
                  productSelectorOpen ? 'rotate-90' : 'rotate-[270deg] '
                )}
              />
            </div>
          </label>
          <div
            className={clsx(
              'grid w-full transition-[grid-template-rows] duration-200',
              productSelectorOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
            )}
          >
            <div
              id="product-selector-container"
              className="overflow-hidden"
            >
              <WallpaperSimulatorProductSelector
                setSelectedProduct={setSelectedProduct}
                products={products}
                totalProductsCount={totalProductsCount}
                currentPage={currentPage}
                pageSize={pageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WallPaperSimulatorConfigurator;
